// extracted by mini-css-extract-plugin
export default {"formWrapper":"Login_formWrapper__it3FU","form":"Login_form__qvtDo","section":"Login_section__2JQEj","labelGroup":"Login_labelGroup__ee8SP"};